import { UserRoles } from './utils';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { useForm } from "react-hook-form";
import { ControlledSelect, ControlledTextField } from '../../shared/components/controlledInput/ControlledInputs';
import { useEffect, useMemo } from 'react';

export const CreateUserModal = ({ showadd, handleCloseAdd, lngsltd, storeLocations, handleSave }) => {
    const { handleSubmit, control, formState: { errors, isValid }, reset } = useForm({
        mode: "onChange",
    });

    useEffect(() => {
        reset()
    }, [showadd, reset])

    const storeOptions = useMemo(() => {
        return Object.keys(storeLocations).map(storeID => ({
            label: storeLocations[storeID],
            value: storeID,
        }))
    }, [storeLocations])

    const onSubmit = (data) => {
        handleSave(data)
    };

    return (
        <Dialog
            open={showadd}
            onClose={handleCloseAdd}
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle id="dialog-title" style={{ backgroundColor: '#efedf0' }}>
                    {lngsltd["Add User"]}
                </DialogTitle>
                <DialogContent>

                    <ControlledTextField
                        name="firstName"
                        control={control}
                        label="First Name *"
                        rules={{ required: "First Name is required" }}
                        error={errors.firstName}
                        helperText={errors.firstName?.message}
                    />

                    <ControlledTextField
                        name="lastName"
                        control={control}
                        label="Last Name *"
                        rules={{ required: "Last Name is required" }}
                        error={errors.lastName}
                        helperText={errors.lastName?.message}
                    />

                    <ControlledTextField
                        name="email"
                        control={control}
                        label="Email *"
                        rules={{
                            required: "Email is required",
                            pattern: {
                                value: /^\S+@\S+$/i,
                                message: "Invalid email format",
                            }
                        }}
                        error={errors.email}
                        helperText={errors.email?.message}
                    />

                    <ControlledTextField
                        name="password"
                        control={control}
                        label="Password *"
                        type="password"
                        rules={{
                            required: "Password is required",
                            pattern: {
                                value: /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()_+])[A-Za-z0-9!@#$%^&*()_+]{8,}$/,
                                message: "Password must contain at least 8 characters, including one capital letter, one number, and one symbol",
                            },
                        }}
                        error={errors.password}
                        helperText={errors.password?.message}
                    />

                    <ControlledSelect
                        name="role"
                        control={control}
                        label={lngsltd["Role"]}
                        rules={{ required: "Role is required" }}
                        error={errors.role}
                        helperText={errors.role?.message}
                        options={UserRoles.map(role => ({ label: role, value: role }))}
                    />

                    <ControlledSelect
                        name="store"
                        control={control}
                        label={lngsltd["Store Location"]}
                        type="select"
                        options={storeOptions}
                    />

                </DialogContent>
                <DialogActions>
                    <Button type="submit" variant="contained" color="primary" onClick={onSubmit} disabled={!isValid}>
                        {lngsltd["Add"]}
                    </Button>
                    <Button variant="outlined" color="error" onClick={handleCloseAdd} style={{ marginLeft: 8 }}>
                        {lngsltd["Cancel"]}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

